var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('MultiVariableLineChart',{attrs:{"title":"Histórico de variables","vars":_vm.vars,"selected_var":_vm.selected_var,"is_analizador":_vm.is_analizador}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }